import * as copy from 'copy-to-clipboard';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { FLYBITS } from '../../../constants';
import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class WebhookForm extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Typography>POST {FLYBITS.I9N_HOST}/paymi/webhook/xxxxx</Typography>
                <Button onClick={this.props.generateWebhook} color="primary">Generate</Button>
                <Button onClick={this.copyWebhookUrl} color="primary">Copy to Clipboard</Button>
            </div>
        );
    }
    private copyWebhookUrl = () => {
        copy(FLYBITS.I9N_HOST + '/paymi/webhook/' + this.props.config.webhook)
    }

}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(WebhookForm));



// WEBPACK FOOTER //
// ./src/sub-projects/paymi/components/webhook-form.tsx